import * as axiosService from "../service/axiosService";

export const fetchCountryCodeFromGeo = async () => {
  // Wrap geolocation in a Promise
    const getCurrentPosition = () =>
        new Promise((resolve, reject) =>
            navigator.geolocation.getCurrentPosition(resolve, reject)
        );

    try {
        const position = await getCurrentPosition();
        const { latitude, longitude } = position.coords;

        const response = await axiosService.Get(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
        );

        const countryCode = response?.data?.address?.country_code?.toUpperCase();
        if (countryCode) {
        return countryCode;
        } else {
        console.warn("Country code not found in response:", response);
        return null;
        }
    } 
    catch (err) {
        console.error("Error getting country code from geolocation:", err);
        return null;
    }
};
